import { render, staticRenderFns } from "./ResourceControl.vue?vue&type=template&id=48492881&"
import script from "./ResourceControl.vue?vue&type=script&lang=js&"
export * from "./ResourceControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports